module.exports = __webpack_public_path__ + "static/media/1013015.1296e893.jpg";